export const ActionsName = {
  EditSketch: 'EditSketch',
  ChangeLayerTemplate: 'ChangeLayerTemplate',
  LayerHelp: 'LayerHelp',
  ShowLayerConfigurationMenu: 'ShowLayerConfigurationMenu',
  ShowLayerConfigurationPanel: 'ShowLayerConfigurationPanel'
};
